import React, { useEffect, useState } from "react";
import LeftSideNavigation from "../../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../../../navigationSection/TopNavigationBarMobile";
import { Container, Col, Form, Row, Image, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Formik, useFormik } from "formik";
import moment from "moment";
import { useSelector } from "react-redux";
import Alert from "react-s-alert";
import GuestData from "./GuestData";
import { amApi } from "../../../../../api/apiHelper";
import { errorAlert, successAlert } from "../../../../../function/alert";
import { isEmpty } from "lodash";
import GuestForm from "./GuestForm";
import PaymentExperience from "./PaymentExp";

const AddExperienceGuest = ({ ...props }) => {
    const history = useHistory();
    console.log(history?.location?.state);
    let exp = history?.location?.state;
    const reqId = history?.location?.pathname?.split('/')?.[3];
    if (history?.location?.state?.type == "PAY_NOW") {
        exp = history?.location?.state?.data
    }
    const [path, setPath] = useState("ADD");
    const [experience, setExperience] = useState({});
    const [reservationSlots, setReservationSlots] = useState([]);
    const [count, setCount] = useState(1);

    const vendor = useSelector((state) => state.auth?.user?.VendorUser || "");
    const rest = useSelector((state) => state.auth?.onboarding?.restaurantDetails?._id);

    const getAllData = async () => {
        if(reqId){
            await amApi.get(`/expRequest/${reqId}`).then(res => {
                exp = res.data;
                formik.setValues(res.data);
                setExperience(res.data);
            });
            setPath("PAYMENT");
        }
    }
    useEffect(() => {
        if(reqId && path != "PAYMENT"){
            getAllData();
        }
    }, [reqId])
    const formik = useFormik({
        initialValues: GuestData.initialValues,
        validationSchema: GuestData.validation,

        onSubmit: (values) => {
            if (path === "PAYMENT") {
                amApi.post('/experience', values).then(res => {
                    successAlert('Experience Create Successfully');
                    formik.resetForm();
                }).catch(err => {
                    errorAlert(err?.response?.data?.message || "Something went wrong, try again later")
                });
            }
        }
    });

    const paymentPage = () => {
       
        if ((experience?.expType === "CURATED" && (formik.values.package.count < 1 && formik.values.adultCount + formik.values.kidsCount < experience?.minSeats))) {
            errorAlert(`Minimum ${experience?.minSeats} tickets required.`)
        } else if ((experience?.expType === "CURATED" && formik.values.adultCount + formik.values.kidsCount > experience?.maxSeats)) {
            errorAlert(`Maximum ${experience?.maxSeats} tickets allowed per bookings.`)
        } else if ((formik.values.package.count == 0 && formik.values.adultCount == 0 && formik.values.kidsCount == 0)) {
            errorAlert('At least one adult or package should be selected')
        }else if (formik.values?.adultPriceChanged && formik.values.adultPrice <= 0){
            errorAlert('Price is required')
        } else if (isEmpty(formik.errors)) {
            setPath('PAYMENT');
        } else {
            formik.handleSubmit();
            Alert.error(`<h4>Please fill the  required fields</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
            });
        }
        setCount(count + 1);
    }

    const onCancel = () => {
        history.goBack()
    }

    useEffect(() => {
        if (vendor?.country_code) formik.setFieldValue('userDetails.countryCode', vendor?.country_code);
    }, [vendor])

    useEffect(() => {
        setExperience(exp);
        formik.setValues({ ...formik.values, adultPrice: exp?.adultPrice, kidsPrice: exp?.kidsPrice, expType: exp?.expType, experienceId: exp?._id, vendorId: exp?.vendorId, restaurantId: exp?.restaurantId })
        if (exp?.timings?.days?.length === 1) {
            formik.setFieldValue('reservationDate', moment(exp?.timings?.days[0], 'DD-MM-YYYY').format('YYYY-MM-DD'));
        }
    }, [exp]);

    useEffect(() => {
        async function fetchData() {
            let response = await amApi(`/user-check?mobile_number=${formik.values?.userDetails?.mobileNumber}&country_code=${formik.values?.userDetails?.countryCode}`);
            if (response.status === 200 && !isEmpty(response.data)) {
                let userDetails = { name: `${response.data?.first_name} ${response.data?.last_name}`, email: response.data?.email, fcmToken: response.data.FCMtoken || "", mobileNumber: response.data.mobile_number, countryCode: response.data.country_code }
                formik.setFieldValue('userDetails', userDetails);
                formik.setFieldValue('userId', response.data._id);
            }
        }
        if (/^[6-9]{1}[0-9]{9}$/.test(formik.values?.userDetails?.mobileNumber)) {
            fetchData()
        }
    }, [formik.values?.userDetails?.mobileNumber])

    const   Validatecurated = (date) => {
        try{
            if(!experience?.timings[moment(date).format("DD-MM-YYY")].open){
                errorAlert('curated experience close ');
            }
        }catch(err){
            console.error(err);
        }
      }

      const   Validatespecial = (date) => {
        if(!experience?.timings?.moment(date).format("DD-MM-YYY").open){
            errorAlert(' special Not Available');
        }
      }

    const validateOpen = (date) => {
        if(experience.expType === 'CURATED'){
          Validatecurated(date);
        }else {
          Validatespecial(date);
        }}
     
    useEffect(() => {
        async function fetchData() {
            let response = await amApi(`/restaurant-availability`, { params: { id: rest, date: formik?.values?.reservationDate, expId: exp?._id } });
            setReservationSlots(response.data)
           // console.log(reservationSlots,"reservtionslots");
            if (response.data.length === 0) {
                errorAlert('No Slots Available');
            }
        }
        if (!isEmpty(exp?._id) && path === 'ADD' && formik.values?.reservationDate) {
            fetchData()
        }
       // validateOpen(formik.values?.reservationDate);
     
    }, [formik.values?.reservationDate])

    // if (props?.location?.state?.expType === "SPECIAL")

    const backPage = (e) => {
        setPath("ADD");
    }
    return (
        <React.Fragment>
            <Container fluid>
                <Row>
                    <div className="left-side-panel">
                        <LeftSideNavigation />
                    </div>
                    <div className="top-panel">
                        <TopNavigationBarMobile displayLeft="logo" />
                    </div>
                    <div className="right-side-panel">
                        <RightSideNavigation
                            history={history}
                            leftText={"history"}
                            displayText={'Back'}
                            noEnAdminPic={true} />
                        {path === 'ADD' ?
                            <GuestForm experience={experience} paymentPage={paymentPage} formik={formik} onCancel={onCancel} reservationSlots={reservationSlots} count={count} /> :
                            <PaymentExperience experience={experience} backPage={backPage} formik={formik} onCancel={onCancel} reqId={reqId} />
                        }
                    </div>
                </Row>
            </Container>
        </React.Fragment >
    );
};

export default AddExperienceGuest;